<template>
	<form class='form' @submit.stop.prevent="submit">
		<h4>Мониторинг актов ЛПО (редактирование)</h4>
		<div class="row">
			<div class="col-sm-1 col"><span class="bold">№ акта ЛПО *</span></div>
			<div class="col-sm-2 col"><span class="bold">Организация *</span></div>
			<div class="col-sm-6 col">Ссылка на акт</div>
		</div>
		<div class="row">
			<div class="col-sm-1 col"><input type="text" v-model='f_2' class='form-control my-control' :class='fields_correct.f_2' :disabled='readonly'></input></div>
			<div class="col-sm-2 col"><organization :org_id='f_11' :disabled='readonly' :field_class='fields_correct.f_11'></organization></div>
			<div class="col-sm-6 col"><input type="text" v-model='f_4' class='form-control my-control' :disabled='readonly'></input></div>
		</div>
		<div class="row">
			<div class="col-sm-3 col">Федеральный округ</div>
			<div class="col-sm-3 col"><span class="bold">Субъект РФ *</span></div>
			<div class="col-sm-3 col"><span class="bold">Лесничество *</span></div>
		</div>
		<div class="row">
			<div class="col-sm-3 col"><fo type='add' :reg_id='f_12'></fo></div>
			<div class="col-sm-3 col">
				<region type='edit' :reg_id='f_12' :disabled='readonly' :field_class='fields_correct.f_12'></region>
			</div>
			<div class="col-sm-3 col">
				<forestry type='edit' :reg_id='f_12' :f_id='f_9' :disabled='readonly' :field_class='fields_correct.f_9'></forestry>
			</div>
		</div>
		<hr>

		<div class="row">
			<div class="col-sm-7" style="margin-bottom: 5px;">
				<input id='btnAddLine' @click='addLine' value='Добавить' type='button' :disabled='readonly' :class='lines_correct'/> <input id='btnCopyLine' @click='copyLine' value='Дублировать отмеченное' type='button' disabled='true' /> <input id='btnDeleteLine' @click='deleteLine' value='Удалить отмеченное' type='button' :disabled='readonly' />
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12">
				<div class='table_head_wrap'>
					<table class='place_table place_table__top'>
						<thead>
							<tr>
								<th class="form_td_chkbox"><input id="chkBoxSelAll" @click='selectAll' type='checkbox' :disabled='readonly'/></th>
								<th class="form_td">Участковое лесничество *</th>
								<th class="form_td">Подлес-во</th>
								<th class="form_td">Квартал *</th>
								<th class="form_td">Выдел *</th>
								<th class="form_td">S выдела *</th>
								<th class="form_td">Лп. выдел</th>
								<th class="form_td">S лп. выдела</th>
								<th class="form_td">Состав</th>
								<th class="form_td">Возраст</th>
								<th class="form_td">Полнота</th>
								<th class="form_td">Запас</th>
								<location-table-field field_name="f_131" @set="setSKSAllLocations" title="СКС насаждения">
									СКС насаждения
								</location-table-field>
								<th class="form_td">МЗЛ *</th>
								<th class="form_td">S МЗЛ (для РАД шт.)</th>
								<th class="form_td">V(м<sup>3</sup>)</th>
								<!-- -->
								<th class="form_td">Целевое назначение лесов</th>
								<th class="form_td">Категория защитных лесов</th>
								<th class="form_td">ОЗУ</th>
								<!-- -->
								<th class="form_td">Порода</th>
								<th class="form_td">Причина ослабления</th>
								<th class="form_td">Комментарии</th>
								<th :width='scroll_width'></th>
							</tr>
						</thead>
					</table>
				</div>
				<div class='table_body_wrap'>
					<table class='place_table place_table__bottom'>
						<tbody>
							<tr v-for='(line, index) in lines'>
								<td class="form_td_chkbox">
									<input type="checkbox" class="checkbox control-access-first" :data-index='index' :disabled='readonly'/>
								</td>
								<td class='form_td' :class='line.correct_f_20'>
									<localforestry :line_count='index' type='edit' :disabled='readonly' :f_id='line.f_9' :lf_id='line.f_20'></localforestry>
								</td>
								<td class='form_td' style='border-right: none'>
									<subforestry :line_count='index' type='edit' :disabled='readonly' :lf_id='line.f_20' :sf_id='line.f_27'></subforestry>
								</td>
								<td class='form_td' :class='line.correct_f_17'>
									<input type="text" class='table-control form-control my-control' @keyup='tdChange' v-model='line.f_17' :disabled='readonly' data-field='f_17' :line_count='index'></input>
								</td>
								<td class='form_td' :class='line.correct_f_24'>
									<input type="text" class='table-control form-control my-control' @keyup='tdChange' v-model='line.f_24' :disabled='readonly'  data-field='f_24' :line_count='index'></input>
								</td>
								<td class='form_td' :class='line.correct_f_21'>
									<input type="text" @keyup='e => {tdChange(e)}' class='table-control form-control my-control' v-model='line.f_21' :disabled='readonly' data-field='f_21' :line_count='index'></input>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_25' :disabled='readonly'></input>
								</td>
								<td class='form_td' style='border-right: none' :class='line.correct_f_23'>
									<input type="text" @keyup='calcSLP' class='table-control form-control my-control' data-field='f_23' :data-line='index' v-model='line.f_23' :disabled='readonly'></input>
								</td>
								<!-- -->
								<td class='form_td' style='border-right: none' :class='line.correct_f_111'>
									<input type="text" class='table-control form-control my-control' data-field='f_111' :data-line='index' v-model='line.f_111' :disabled='readonly'></input>
								</td>
								<td class='form_td' style='border-right: none' :class='line.correct_f_112'>
									<input type="text" class='table-control form-control my-control' data-field='f_112' :data-line='index' v-model='line.f_112' :disabled='readonly'></input>
								</td>
								<td class='form_td' style='border-right: none' :class='line.correct_f_113'>
									<input type="text" class='table-control form-control my-control' data-field='f_113' :data-line='index' v-model='line.f_113' :disabled='readonly'></input>
								</td>
								<td class='form_td' style='border-right: none' :class='line.correct_f_114'>
									<input type="text" class='table-control form-control my-control' data-field='f_114' :data-line='index' v-model='line.f_114' :disabled='readonly'></input>
								</td>
								<td class='form_td' style='border-right: none' :class='line.f_131 ? "" : "field-error"'>
									<input type="text" class='table-control form-control my-control' data-field='f_131' :data-line='index' v-model='line.f_131' :disabled='readonly'></input>
								</td>
								<!-- -->
								<td class='form_td'>
									<action-type :line_count='index' :disabled='readonly' :at_id='line.f_16'></action-type>
								</td>
								<td class='form_td' style="position: relative;">
									<input type="text" @keyup='calcSAT' class='table-control form-control my-control' data-field='f_22' :data-line='index' v-model='line.f_22' :disabled='readonly' @blur='(e) => {tryBlurMzl(e, line.f_22, line.f_16 == mzlRAD.id)}'></input>
									<tooltip-warn :value='line.f_22' :type-is-rad='line.f_16 == mzlRAD.id' :key='index' :id='index'></tooltip-warn>
								</td>
								<!-- -->
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' data-field='f_116' :data-line='index' v-model='line.f_116' :disabled='readonly'></input>
								</td>
								<td class='form_td'>
									<forest-purpose :line_count='index' type='edit' :id='line.f_104' :disabled='readonly'></forest-purpose>
								</td>
								<td class='form_td'>
									<protective-cat :line_count='index' type='edit' :id='line.f_105' :disabled='readonly'></protective-cat>
								</td>
								<td class='form_td'>
									<protective-cat-ext :line_count='index' type='edit' :id='line.f_106' :disabled='readonly'></protective-cat-ext>
								</td>
								<!-- -->
								<td class='form_td'>
									<species :line_count='index' :disabled='readonly' :sp_id='line.f_26'></species>
								</td>
								<td class='form_td'>
									<damage-reason :line_count='index' :disabled='readonly' :dmg_id='line.f_19'></damage-reason>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_18' :disabled='readonly'></input>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<!-- <div class="row">
			<div class="col-md-5"></div>
			<div class="col-md-1"><span style='vertical-align: sub'>Итого</span></div>
			<div class="col-md-1"><input v-model='summ_s_lp' type="text" class='form-control my-control' disabled></input></div>
			<div class="col-md-1"></div>
			<div class="col-md-1"><input v-model='summ_s_action_type' type="text" class='form-control my-control' disabled></input></div>
		</div> -->
		<div class="row" style="margin-top: 20px; margin-bottom: 10px;">
			<div class="col-md-1" style='padding-right: 0;'>
				<div class='left_input_wrapper'>
					<span class="bold">S ЛПО *</span>
					<input type="text" style='float:right;' class='short_plus form-control my-control' v-model='f_13' :disabled='readonly' :class='fields_correct.f_13'></input>
				</div>

				<!-- <div class='left_input_wrapper'>
					<span class="bold">V(м<sup>3</sup>)</span>
					<input type="text" style='float:right;' class='short form-control my-control' v-model='f_115' :disabled='readonly' :class='fields_correct.f_115'></input>
				</div> -->
			</div>

			

			<!--
			<div class="col-md-1">
				УАД/шт.
				<input type="text" class='short form-control my-control' v-model='f_14' :disabled='readonly'></input>
			</div> -->
			<div class="col-md-11">
				<table class='table-mzl'>
					<thead>
						<tr>
							<th>
								S лп. выдела
							</th>
							<th>
								{{ mzlRAD.name }}
							</th>
							<th>
								V(м<sup>3</sup>)
							</th>
							<th v-for='item in mzlNoRAD'>
								{{ item.name }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td rowspan='2'>{{ summ_s_lp }}</td>
							<td rowspan='2'>{{ mzlRAD.value }}</td>
							<td rowspan='2'>{{ value_summ }}</td>
							<td v-for='item in mzlNoRAD'>
								{{ item.value }}
							</td>
						</tr>
						<tr>
							<td :colspan='mzl.length'>{{ floatConvert(summ_s_action_type - mzlRAD.value) }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="row">
			<!-- <div class="col-md-2"></div> -->
			<div class="col-md-1 col-md-offset-2">
				<label>Контроль 3 дня</label>
			</div>
			<div class="col-md-1" style="margin-left:6.33%">
				<label>Даты</label>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-8">
				<table class='dateTable'>
					<thead>
						<tr>
							<th>проведения ЛПО *</th>
							<th>утверждения *</th>
							<th>размещения на сайте *</th>
							<th>контроль 20 дней</th>
							<th>осталось дней</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td :class='fields_correct.f_1'>
								<datepicker
									v-model='f_1'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker>
							</td>
							<td :class='fields_correct.f_5'>
								<datepicker
									id='edit_datepicker_f_5'
									v-model='f_5'
									format='dd.MM.yyyy'
									:disabled='readonly'
									@input='adoptionChange'
									class='table-control'
								></datepicker>
							</td>
							<td :class='fields_correct.f_3'>
								<datepicker
									id='edit_datepicker_f_3'
									@input='placeChange'
									v-model='f_3'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker>
							</td>
							<td>
								<input type="text" class='table-control form-control my-control'v-model='controlTwenty' disabled></input>
							</td>
							<td>
								<input type="text" class='table-control form-control my-control' v-model='daysLeft' disabled></input>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-4">
				<div class="rent-title">Аренда</div>
				<select v-model='f_126' class='form-control my-control medium' :class='fields_correct.f_126'>
					<option :value="null"></option>
					<option :value="true">Да</option>
					<option :value="false">Нет</option>
				</select>
			</div>
		</div>
		<div class="row" style='margin: 5px;'></div>
		<div class="row">
			<div class="col-sm-8">
				<table class="dateTable">
					<thead>
						<tr>
							<th>Основание проведения ЛПО</th>
							<th>Метод проведения ЛПО</th>
							<th>Способ проведения ЛПО</th>
						</tr>
					</thead>
					<tbody>
						<td><lpo-reason :disabled='readonly'></lpo-reason></td>
						<td><lpo-method :disabled='readonly'></lpo-method></td>
						<td><lpo-mode :disabled='readonly' :method='f_89'></lpo-mode></td>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row" style='margin: 5px;'></div>
		<div class="row">
			<div class="col-sm-8">
				<table class='dateTable'>
					<thead>
						<tr>
							<th>Дата снятия с сайта</th>
							<th>Причина снятия с сайта Акта ЛПО</th>
							<th>Ответственный за заключение на акты ЛПО</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<datepicker
									v-model='f_7'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker>
							</td>
							<td><deletion-reason :disabled='readonly'></deletion-reason></td>
							<td>
								<conclusion-user :disabled='readonly || conclusion_user_disabled'></conclusion-user>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-2">
				<select v-model='f_10' class='form-control form-control my-control medium' :disabled='readonly'>
					<option value="1">Черновик</option>
					<option value="0">Чистовик</option>
				</select>
			</div>
		</div>
		<div class="row" style='margin: 5px;'></div>
		<div class="row">
			<div class="col-sm-8">
				<table class='dateTable no-bottom-border'>
					<thead>
						<tr>
							<th colspan="4">Исполнитель работ по ЛПО</th>
						</tr>
					</thead>
				</table>
				<table class='dateTable'>
					<tbody>
						<tr>
							<td style="width: 15%;" class="no-right-border">ФИО</td>
							<td :class='fields_correct.f_127'>
								<input 
									v-model="f_127" 
									type="text" 
									class='table-control my-control form-control'
								>
							</td>
							<td style="width: 20%;" class="no-right-border">
								<select 
									v-model="f_129"
									@change="change_f_129" 
									class="form-control my-control table-control">
									<option v-for="type in organization_types" :value="type.id" :key="type.id">
										{{ type.name }}
									</option>
								</select>
							</td>
							<td :class='f_129 == 2 ? fields_correct.f_128 : fields_correct.f_130'>
								<select v-if="f_129 == 1" v-model="f_130" class="form-control my-control table-control">
									<option v-for="item in lpo_filials" :value="item.id" :key="item.id">
										{{ item.name }}
									</option>
								</select>
								<input 
									v-if="f_129 == 2"
									v-model="f_128" 
									type="text" 
									class='table-control my-control form-control'
								>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<hr>

		<div class='btnPanel'>
			<!-- <b-button class='clearBtn' @click.prevent='clearForm' variant='secondary'>Очистить</b-button> -->
			<input type='button' class='btn btn-secondary' @click.prevent="close" value='Отмена' :disabled="readonly"></input>
			<!-- <input type='button' class='btn btn-primary' @click='submit' value='Сохранить' :disabled="readonly"></input> -->
			<button class='btn btn-primary' @click.prevent='submit' :disabled="submit_disabled || readonly">
				<i class='fa fa-spinner fa-spin' v-if='submit_disabled'></i>
				{{ submit_disabled ? 'Сохранение' : 'Сохранить' }}
			</button>

		</div>
	</form>
</template>

<script>
	import router from '../../router'
	import auth from '../../auth'

	import fo from './fetch_data/fo'
	import region from './fetch_data/region'
	import forestry from './fetch_data/forestry'
	import localforestry from './fetch_data/localforestry'
	import subforestry from './fetch_data/subforestry'
	import species from './fetch_data/species'
	import conclusionUser from './fetch_data/conclusionUser'
	import organization from './fetch_data/organization'
	import actionType from './fetch_data/actionType'
	import damageReason from './fetch_data/damageReason'
	import deletionReason from './fetch_data/deletionReason'

	import lpoReason from './fetch_data/lpoReason'
	import lpoMethod from './fetch_data/lpoMethod'
	import lpoMode from './fetch_data/lpoMode'

	import forestPurpose from './fetch_data/forestPurpose'
	import protectiveCat from './fetch_data/protectiveCat'
	import protectiveCatExt from './fetch_data/protectiveCatExt'

	import tooltipWarn from './fetch_data/tooltipWarn'

	import locationTableField from './fetch_data/locationTableField'

	import moment from 'moment';
	// import jQuery from "jquery";  
	// import datePicker from 'vue-bootstrap-datetimepicker';
	// import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

	import { datepicker } from 'vue-strap'

	import { EventBus } from '../../lib/EventBus'

	import {DB} from './../../constants'
	const HEADER = 'get_header.php'
	const ACT_INFO = 'get_act_info.php'
	const ACT_LOCATION = 'get_act_location.php'
	const GROUP_JSON = 'group_json.php'
	const CAN_EDIT = 'can_edit_unit.php'
	const ACTION_TYPE = 'get_action_type.php'
	const CONCLUSION_EXIST = 'get_conclusion_exist.php'
	const DAMAGES = 'get_damages.php'
	const LOCALFORESTRY = 'localforestrie_list.php'
	const SUBFORESTRY = 'subforestrie_list.php'
	const SPECIES = 'get_species.php'
	const OZU = 'get_ozu.php'
	const PROTECTIVE_CAT = 'get_protective_cat.php'
	const FOREST_PURPOSE = 'get_forest_purpose.php'
	const LPO_FILIALS = 'get_lpo_filials.php'
	const ORGANIZATION_LPO = 'get_organization_lpo.php'
	const UNIT_ID = 1
	const TIMEOUT = 10 * 60 * 1000 //10 минут
/*	const UPDATE_JSON = 'update_json.php'
	const INSERT_JSON = 'insert_json.php'
	const DELETE_JSON = 'delete_json.php'*/

	export default {
		name: 'editModal',
		data: function () {
			return {
				scroll_width: 17,
				readonly: true,
				line_count: 0,
				lines: [],
				mzl: [],
				mzlNoRAD: [],
				mzlRAD: [],
				lines_loaded: false,
				mzl_loaded: false,
				//rec_id: '',
				//old_obj: '',

				f_1: '',
				f_2: '',
				f_3: '',
				f_4: '',
				f_5: '',
				f_6: 0,
				f_7: '',
				f_8: 0,
				f_9: '',
				f_10: 1,
				f_11: '',
				f_12: '',
				f_13: '',
				f_115: '',
				f_14: '',
				f_15: auth.user.id,
				f_89: null,

				f_126: null,
				f_127: null,
				
				f_128: null,
				f_129: null, //organization_lpo_id
				f_130: null, //lpo_filial_id
				
				/*f_16: [],
				f_17: [],
				f_18: [],
				f_19: [],
				f_20: [],
				f_21: [],
				f_22: [],
				f_23: [],
				f_24: [],
				f_25: [],
				f_26: [],
				f_27: [],*/

				f_r: '',
				f_p: '',
				row_id: [],

				controlTwenty: '',
				daysLeft: '',
				prepareToDelete: [],
				act_id: this.$route.params.id,
				summ_s_lp: 0,
				summ_s_action_type: 0,
				value_summ: 0,
				td_correct: '',
				conclusion_user_disabled: false,

				fields_correct: {
					f_1: 'field-error',
					f_2: 'field-error',
					f_3: 'field-error',
					f_5: 'field-error',
					f_9: 'field-error',
					f_11: 'field-error',
					f_12: 'field-error',
					f_13: 'field-error',
					f_115: '',
					f_126: 'field-error',
					f_127: 'field-error',
					f_128: 'field-error',
					f_130: 'field-error'
				},
				
				submit_disabled: false,

				lines_correct: 'field-error',

				data_location: {
					action_type: null,
					damage_reason: null,
					localforestry: null,
					subforestry: null,
					species_list: [],
					ozu: [],
					protective_cat: [],
					forest_purpose: [],
					subforestrie_list: [],
					subforestrie_list_queue: []
				},

				organization_types: [],
				lpo_filials: []
			}
		},
		components: {
			region,
			forestry,
			localforestry,
			subforestry,
			fo,
			species,
			conclusionUser,
			organization,
			actionType,
			damageReason,
			deletionReason,
			datepicker,
			lpoReason,
			lpoMethod,
			lpoMode,
			forestPurpose,
			protectiveCat,
			protectiveCatExt,
			tooltipWarn,
			locationTableField
		},
		computed: {
		},
		methods: {
			tryBlurMzl (e, val, type) {
				//if(type && !Number.isInteger(Number(val)))
				//	setTimeout(() => e.target.focus(), 30)
			},
			floatConvert (number) {
			    return +(parseFloat(number).toPrecision(12))
			},
			filterInput (e) {
				e.target.value = e.target.value.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")
			},
			calcSLP (e) {
				if(typeof e !== 'undefined') {
					e.target.value = e.target.value.replace(/[,-]/g, ".")
					const f = e.target.getAttribute('data-field')
					const l = e.target.getAttribute('data-line')
					this.lines[l][f] = e.target.value
				}

				let s = 0
				for (let i = 0; i < this.lines.length; i++) {
					s += +this.lines[i].f_23
				}

				this.summ_s_lp = this.floatConvert(s)//7.00000000001 FIX
			},
			calcSAT (e) {
				if(typeof e !== 'undefined') {
					e.target.value = e.target.value.replace(/[,-]/g, ".")
					const f = e.target.getAttribute('data-field')
					const l = e.target.getAttribute('data-line')
					this.lines[l][f] = e.target.value
				}

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = 0
				}

				for (let j = 0; j < this.lines.length; j++) {
					for (let i = 0; i < this.mzl.length; i++) {
						if (this.mzl[i].id == this.lines[j].f_16) {
							this.mzl[i].value += +this.lines[j].f_22
						}
					}
				}

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = this.floatConvert(this.mzl[i].value)
				}

				let s = 0
				for (let i = 0; i < this.lines.length; i++) {
					s += +this.lines[i].f_22
				}

				this.summ_s_action_type = this.floatConvert(s)//7.00000000001 FIX
			},
			addLine () {
				let obj = {}
				for (let i = 16; i <= 27; i++) {
					obj[`f_${i}`] = ''
				}

				obj.correct_f_16 = 'field-error'
				obj.correct_f_17 = 'field-error'
				obj.correct_f_20 = 'field-error'
				obj.correct_f_21 = 'field-error'
				obj.correct_f_24 = 'field-error'

				this.lines.push(obj)

				this.lines_correct = ''
			},
			copyLine () {
				//console.warn(this.lines)
				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					if (checkbox.checked) {
						checkbox.checked = false
						let index = checkbox.getAttribute('data-index')
						let line_to_copy = Object.assign({}, this.lines[index])
						line_to_copy.f_c = null
						
						for(let l in line_to_copy)
							if(line_to_copy[l] == null)
								delete line_to_copy[l]

						this.lines.push(line_to_copy)
					}
				})
				document.getElementById('chkBoxSelAll').checked = false
			},
			deleteLine () {
				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					if (checkbox.checked) {
						let index = checkbox.getAttribute('data-index')
						
						checkbox.parentNode.parentNode.remove()

						for (let i = 16; i <= 27; i++) {
							this.lines[index][`f_${i}`] = null
						}

						if (this.lines[index].f_c) {
							this.prepareToDelete.push(this.lines[index].f_c)
						}
						//this.lines.splice(index,1)

						this.lines[index].f_d = true
						//console.log(this.lines)
					}

					let c = true
					for (let i = 0; i < this.lines.length; i++) {
						//console.log(this.lines[i].f_d )
						if (typeof this.lines[i].f_d === 'undefined') {
							c = false
							break
						}
					}
					this.lines_correct = c ? 'field-error' : ''
				})
				document.getElementById('chkBoxSelAll').checked = false
				/*let index = this.lines.indexOf(item);		где item - индекс строки для удаления 
				this.lines.splice(index, 1);*/
			},
			selectAll () {
				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					checkbox.checked = document.getElementById('chkBoxSelAll').checked
				})
			},
			clear () {
				this.lines.forEach(line => {
					line.f_d = true
				})

				document.querySelectorAll('tbody .checkbox').forEach(checkbox => {
					checkbox.parentNode.parentNode.remove()
				})
			},
			checkFields () {
				const main_fields = [1,2,3,5,9,11,12,13]
				const location_fields = [17,20,21,24]
				let result = true
				
				for (let i of main_fields) {
					result = result && !!this[`f_${i}`]	//one false = result false, all true = result true
				}

				result = result && !!this.lines.length	//lines.length == 0 => result false

				let deleted_lines_count = 0
				for (let j = 0; j < this.lines.length; j++) {
					if (this.lines[j].f_d)
						deleted_lines_count++
				}

				for (let i of location_fields) {
					for (let j = 0; j < this.lines.length; j++) {
						if (!this.lines[j].f_d)
							result = result && !!this.lines[j][`f_${i}`]
					}
				}

				if (deleted_lines_count === this.lines.length)	//all lines is deleted => result false
					result = false

				return result
			},
			submit () {
				this.submit_disabled = true

				for (let i = 0; i < this.lines.length; i++) {
					if(this.lines[i].f_16 == this.mzlRAD.id && !Number.isInteger(Number(this.lines[i].f_22)))
					{
						EventBus.$emit(`show_tooltip_mzl_edit`, {id: i})
						this.submit_disabled = false
						return false
					}
				}


				let obj = [{}]
				obj[0].u = []
				obj[0].d = []
				//obj[0].i = []
				obj[0].i = {}
				obj[0].i.tab = []

				obj[0].u.push({})

				obj[0].u[obj[0].u.length - 1].tab_id = 1
				obj[0].u[obj[0].u.length - 1].f_v = {}
				obj[0].u[obj[0].u.length - 1].f_v.f_c = this.$route.params.id
				
				for (let i = 1; i <= 15; i++) {
					if (typeof this[`f_${i}`] !== 'object') {
						if (i === 13 || i === 14) {
							obj[0].u[obj[0].u.length - 1].f_v[`f_${i}`] = this[`f_${i}`] ? commaToPeriod(this[`f_${i}`]) : null
						}
						else if (i === 10) {
							obj[0].u[obj[0].u.length - 1].f_v.f_10 = this.f_10 == '1' ? true : false
						}
						else {
							obj[0].u[obj[0].u.length - 1].f_v[`f_${i}`] = this[`f_${i}`] ? this[`f_${i}`] : null
						}
					}
					else {
						obj[0].u[obj[0].u.length - 1].f_v[`f_${i}`] = this[`f_${i}`] ? this[`f_${i}`].format('DD.MM.YYYY') : null
					}
				}

				obj[0].u[obj[0].u.length - 1].f_v[`f_115`] = this[`f_115`] ? commaToPeriod(this[`f_115`]) : null

				obj[0].u[obj[0].u.length - 1].f_v.f_88 = this.f_88
				obj[0].u[obj[0].u.length - 1].f_v.f_89 = this.f_89
				obj[0].u[obj[0].u.length - 1].f_v.f_90 = this.f_90

				obj[0].u[obj[0].u.length - 1].f_v.f_126 = this.f_126
				obj[0].u[obj[0].u.length - 1].f_v.f_127 = this.f_127
				obj[0].u[obj[0].u.length - 1].f_v.f_128 = this.f_128
				obj[0].u[obj[0].u.length - 1].f_v.f_129 = this.f_129
				obj[0].u[obj[0].u.length - 1].f_v.f_130 = this.f_130

				for (let i = 0; i < this.lines.length; i++) {
					if (this.lines[i].f_c && !this.lines[i].f_d) {
						obj[0].u.push({})

						obj[0].u[obj[0].u.length - 1].tab_id = 2
						obj[0].u[obj[0].u.length - 1].f_v = {}
						obj[0].u[obj[0].u.length - 1].f_v.f_c = this.lines[i].f_c

						for (let j = 16; j <= 26; j++) {
							if (j === 21 || j === 22 || j === 23) {
								obj[0].u[obj[0].u.length - 1].f_v[`f_${j}`] = this.lines[i][`f_${j}`] ? commaToPeriod(this.lines[i][`f_${j}`]) : null
							}
							else {
								obj[0].u[obj[0].u.length - 1].f_v[`f_${j}`] = this.lines[i][`f_${j}`] ? this.lines[i][`f_${j}`] : null
							}
						}

						obj[0].u[obj[0].u.length - 1].f_v['f_27'] = Number(this.lines[i]['f_27']) ? this.lines[i]['f_27'] : null

						obj[0].u[obj[0].u.length - 1].f_v['f_104'] = this.lines[i]['f_104']
						obj[0].u[obj[0].u.length - 1].f_v['f_105'] = this.lines[i]['f_105']
						obj[0].u[obj[0].u.length - 1].f_v['f_106'] = this.lines[i]['f_106'] ? this.lines[i]['f_106'] : null

						obj[0].u[obj[0].u.length - 1].f_v['f_111'] = this.lines[i]['f_111'] ? this.lines[i]['f_111'] : null
						obj[0].u[obj[0].u.length - 1].f_v['f_112'] = this.lines[i]['f_112'] ? this.lines[i]['f_112'] : null
						obj[0].u[obj[0].u.length - 1].f_v['f_113'] = this.lines[i]['f_113'] ? this.lines[i]['f_113'] : null
						obj[0].u[obj[0].u.length - 1].f_v['f_114'] = this.lines[i]['f_114'] ? this.lines[i]['f_114'] : null
						obj[0].u[obj[0].u.length - 1].f_v['f_116'] = this.lines[i]['f_116'] ? this.lines[i]['f_116'] : null
						obj[0].u[obj[0].u.length - 1].f_v['f_131'] = this.lines[i]['f_131'] ? this.lines[i]['f_131'] : null

					}
					else if (this.lines[i].f_d) {
						obj[0].d.push({})

						obj[0].d[obj[0].d.length - 1].tab_id = 2
						obj[0].d[obj[0].d.length - 1].f_c = this.lines[i].f_c
					}
					else {
						//obj[0].i.push({})
						obj[0].i.tab.push({})

						obj[0].i.tab[obj[0].i.tab.length - 1].tab_id = 2
						obj[0].i.tab[obj[0].i.tab.length - 1].f_v = {}
						obj[0].i.tab[obj[0].i.tab.length - 1].f_v.f_p = this.$route.params.id
						//console.log(this.$route.params.id)

						for (let j = 16; j <= 26; j++) {
							if (this.lines[i][`f_${j}`])
								if (j === 21 || j === 22 || j === 23) {
									obj[0].i.tab[obj[0].i.tab.length - 1].f_v[`f_${j}`] = commaToPeriod(this.lines[i][`f_${j}`])
								}
								else {
									obj[0].i.tab[obj[0].i.tab.length - 1].f_v[`f_${j}`] = this.lines[i][`f_${j}`]
								}
						}
						if(Number(this.lines[i]['f_27']))
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_27'] = this.lines[i]['f_27']

						obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_104'] = this.lines[i]['f_104']
						obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_105'] = this.lines[i]['f_105']
						if(this.lines[i]['f_106'])
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_106'] = this.lines[i]['f_106']

						if(this.lines[i]['f_111'])
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_111'] = this.lines[i]['f_111']
						if(this.lines[i]['f_112'])
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_112'] = this.lines[i]['f_112']
						if(this.lines[i]['f_113'])
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_113'] = this.lines[i]['f_113']
						if(this.lines[i]['f_114'])
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_114'] = this.lines[i]['f_114']
						if(this.lines[i]['f_116'])
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_116'] = this.lines[i]['f_116']
						if(this.lines[i]['f_131'])
							obj[0].i.tab[obj[0].i.tab.length - 1].f_v['f_131'] = this.lines[i]['f_131']
					}
				}

				// console.log(JSON.stringify(obj)) 
				const submit_act_info = () => {
					let form = new FormData()
							form.append('json', JSON.stringify(obj))

							let first_check_result = null
							let second_check_result = null
							
							const first_check = setTimeout(() => {
								if(first_check_result === null)
								{
									first_check_result = false
									const save = confirm('Во время сохранения акта произошла ошибка. Сохранить файл с отладочной информацией для отправки разработчикам?')

									if(save) 
										this.download(JSON.stringify(obj) + '_timeout', 'edit_' + Date() + '.json', 'text/json')
									
									this.submit_disabled = false

								}
							}, TIMEOUT)

							fetch(DB + GROUP_JSON, {
								credentials: 'include',
								method: 'post',
								body: form
							})
							.then(result => result.json())
							.then(result => {
								if(first_check_result === null)
								{
									first_check_result = true
									clearTimeout(first_check)

									if(result[0].code === '0') {
										alert('Акт сохранен')
										
										if(this.$parent.lastJournalURL)
											router.replace(this.$parent.lastJournalURL)
										else
											router.replace('/main')
									}
									else {
										alert('Во время сохранения акта произошла ошибка. На Ваш компьютер будет сохранён файл с отладочной информацией. Перешлите данный файл вместе со скриншотом экрана разработчикам для выявления и устранения ошибки.')
										this.download(JSON.stringify(obj) + '_' + result[0].name, 'edit_' + Date() + '.json', 'text/json')
									}
									this.submit_disabled = false
								}
							})
							.catch(err => {
								console.log(err)
								this.submit_disabled = false
							})
				}
				if (this.checkFields()) {
					if(document.querySelector('.field-error') !== null)
					{
						const b = confirm('Часть полей может содержать некорректные данные. Вы уверены, что хотите продолжить?')
						if(b)
						{
							submit_act_info()
						} else
						{
							this.submit_disabled = false
						}
					} else {
						submit_act_info()
					}				
				}
				else {
					alert('Поля, отмеченные звёздочкой, обязательны к заполнению.')
					this.submit_disabled = false
				}

				//console.log(this.prepareToDelete)
			},
			close () {
				if(this.$parent.lastJournalURL)
					router.replace(this.$parent.lastJournalURL)
				else
					router.replace('/main')
			},
			download(content, fileName, contentType) {
			    var a = document.createElement("a");
			    var file = new Blob([content], {type: contentType});
			    a.href = URL.createObjectURL(file);
			    a.download = fileName;
			    var event = document.createEvent("MouseEvents");
		        event.initMouseEvent(
		                "click", true, false, window, 0, 0, 0, 0, 0
		                , false, false, false, false, 0, null
		        );
			    a.dispatchEvent(event);
			},
			adoptionChange (e) {
				const dp_adoption = document.getElementById('edit_datepicker_f_5').firstChild
				const dp_placement = document.getElementById('edit_datepicker_f_3').firstChild

				if (e) {
					if (this.f_3) {
						const adoption = moment(e, 'DD.MM.YYYY')
						const place = moment(this.f_3, 'DD.MM.YYYY')
						const diff = place.diff(adoption, 'days')

						if (diff < 0 || diff > 3) {
							if (!dp_adoption.classList.contains('error')) {
								dp_adoption.classList.add('error')
								dp_placement.classList.add('error')
								this.fields_correct.f_3 = 'error'
								this.fields_correct.f_5 = 'error'
							}
						}
						else {
							dp_adoption.classList.remove('error')
							dp_placement.classList.remove('error')
							this.fields_correct.f_3 = ''
							this.fields_correct.f_5 = ''
						}
					}
					else {
						this.fields_correct.f_5 = 'field-success'
					}
				}
				else {
					dp_adoption.classList.remove('error')
					dp_placement.classList.remove('error')
					this.fields_correct.f_5 = 'field-error'
					this.fields_correct.f_3 = this.fields_correct.f_3 !== 'field-error' ? 'field-success' : 'field-error'
				}
			},
			placeChange (e) {
				if (e) {
					let d = moment(e, 'DD.MM.YYYY')
					d.add(20, 'd')
					let now = moment()

					this.controlTwenty = d.format('DD.MM.YYYY')
					this.daysLeft = d.diff(now, 'days')

					if (this.f_5) {
						const adoption = moment(this.f_5, 'DD.MM.YYYY')
						const place = moment(e, 'DD.MM.YYYY')
						const diff = place.diff(adoption, 'days')

						let dp_adoption = document.getElementById('edit_datepicker_f_5').firstChild
						let dp_placement = document.getElementById('edit_datepicker_f_3').firstChild

						if (diff < 0 || diff > 3) {
							if (!dp_adoption.classList.contains('error')) {
								dp_adoption.classList.add('error')
								dp_placement.classList.add('error')
								this.fields_correct.f_3 = 'error'
								this.fields_correct.f_5 = 'error'
							}
						}
						else {
							dp_adoption.classList.remove('error')
							dp_placement.classList.remove('error')
							this.fields_correct.f_3 = ''
							this.fields_correct.f_5 = ''
						}
					}
					else {
						this.fields_correct.f_3 = ''
					}
				}
				else {
					this.controlTwenty = ''
					this.daysLeft = ''

					document.getElementById('edit_datepicker_f_3').firstChild.classList.remove('error')
					document.getElementById('edit_datepicker_f_5').firstChild.classList.remove('error')
					this.fields_correct.f_3 = 'field-error'
					this.fields_correct.f_5 = this.fields_correct.f_5 !== 'field-error' ? 'field-success' : 'field-error'

				}
			},
			checkS_LPO () {
				const locations_S_sum = this.lines.length ? this.lines.reduce((a, cur) => {return a + Number(cur.f_21)}, 0) : 0
				const locations_S_MZL_sum = this.lines.length ? this.lines.reduce((a, cur) => {
					//console.warn(cur)
					return a + (cur.f_16 == 563 ? 0 : Number(cur.f_22))//Для всех, кроме РАД
				}, 0) : 0
				//console.warn(Number(this.f_13), locations_S_sum, locations_S_MZL_sum)
				this.fields_correct.f_13 = (this.f_13 === '' || this.f_13 === null || Number(this.f_13) > locations_S_sum || Number(this.f_13) < locations_S_MZL_sum) ? 'field-error' : ''
			},
			tdChange(e) {
				const f = e.target.getAttribute('data-field')
				const l = e.target.getAttribute('line_count')
				if (f === 'f_21') {
					e.target.value = e.target.value.replace(/[,-]/g, ".")
				}
				
				this.lines[l][`correct_${f}`] = e.target.value === '' ? 'field-error' : 'place-success'
			},
			change_f_129() {
				this.f_130 = null
				this.f_128 = ""
			},
			setSKSAllLocations(val) {
				for (const iterator of this.lines) {
					iterator[val.field] = val.value
				}
			}
		},
		created () {
			fetch(DB + ACTION_TYPE, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if (res) {
					this.data_location.action_type = res
					EventBus.$emit(`fetch_action_type_complete`, {data: res})

					let tmp = []
					for (let i = 1; i < res.length; i++) {
						tmp.push({id: +res[i].id, name: res[i].name, value: 0})
					}
					this.mzl = tmp
				}
				else
					this.mzl = []
				this.mzl_loaded = true
				if(this.lines_loaded)
				{
					this.calcSLP()
					this.calcSAT()
				}
			})
			.catch(err => console.log(err))

			fetch(DB + DAMAGES, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.data_location.damage_reason = data
					EventBus.$emit(`fetch_damage_reason_complete`, data)
				}
			})
			.catch(err => console.log(err))

			fetch(DB + LPO_FILIALS, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.lpo_filials = data
				}
			})
			.catch(err => console.log(err))

			fetch(DB + ORGANIZATION_LPO, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.organization_types = data
				}
			})
			.catch(err => console.log(err))

			fetch(DB + OZU, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.data_location.ozu = data
					EventBus.$emit(`fetch_ozu_complete`, data)
				}
			})
			.catch(err => console.log(err))

			fetch(DB + PROTECTIVE_CAT, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.data_location.protective_cat = data
					EventBus.$emit(`fetch_protective_cat_complete`, data)
				}
			})
			.catch(err => console.log(err))

			fetch(DB + FOREST_PURPOSE, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.data_location.forest_purpose = data
					EventBus.$emit(`fetch_forest_purpose_complete`, data)
				}
			})
			.catch(err => console.log(err))

			EventBus.$on('edit_region', (id) => {
				this.f_12 = id
				this.f_9 = 0
				this.clear()
				this.fields_correct.f_12 = (id === '0') ? 'field-error' : ''
				this.fields_correct.f_9 = 'field-error'
			})
			EventBus.$on('init_region_correct', (id) => {
				this.fields_correct.f_12 = (id === '0') ? 'field-error' : ''
			})
			EventBus.$on('edit_forestry', (id) => {
				this.f_9 = id

				fetch(DB + LOCALFORESTRY + '?id=' + this.f_9)//forestry_id - f_9
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.data_location.localforestry = data
							EventBus.$emit(`fetch_localforestry_complete`, data)
						}
					})
					.catch(err => console.log(err))

				this.clear()
				this.fields_correct.f_9 = (id === '0') ? 'field-error' : ''

				this.addLine()
			})
			EventBus.$on('init_forestry_correct', (id) => {
				this.fields_correct.f_9 = (id === '0') ? 'field-error' : ''
			})
			EventBus.$on('edit_localforestry', data => {
				this.lines[data.index].f_20 = data.value
				this.lines[data.index].correct_f_20 = +data.value === 0 ? 'field-error' : 'place-success'
			})
			EventBus.$on('edit_subforestry', data => {
				this.lines[data.index].f_27 = data.value
			})
			EventBus.$on('edit_conclusion_user', id => {
				this.f_6 = id
			})
			EventBus.$on('edit_species', data => {
				this.lines[data.index].f_26 = data.value
			})
			EventBus.$on('edit_organization', id => {
				this.f_11 = id
				this.fields_correct.f_11 = (id === '0') ? 'field-error' : ''
			})
			EventBus.$on('edit_action_type', data => {
				this.lines[data.index].f_16 = +data.value

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = 0
				}

				for (let j = 0; j < this.lines.length; j++) {
					for (let i = 0; i < this.mzl.length; i++) {
						if (this.mzl[i].id == this.lines[j].f_16) {
							this.mzl[i].value += +this.lines[j].f_22
						}
					}
				}

				for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = this.floatConvert(this.mzl[i].value)
				}

				this.checkS_LPO()				
			})
			EventBus.$on('edit_deletion_reason', id => {
				this.f_8 = id
			})
			EventBus.$on('edit_damages', data => {
				this.lines[data.index].f_19 = data.value
			})

			EventBus.$on('edit_lpo_reason', id => {
				this.f_88 = id
			})

			EventBus.$on('edit_lpo_method', id => {
				this.f_89 = id
			})

			EventBus.$on('edit_lpo_mode', id => {
				this.f_90 = id
			})

			//---------------------
			EventBus.$on('edit_forest_purpose', data => {
				this.lines[data.index].f_104 = data.value
			})
			EventBus.$on('edit_protective_cat', data => {
				this.lines[data.index].f_105 = data.value
			})
			EventBus.$on('edit_protective_cat_ext', data => {
				this.lines[data.index].f_106 = data.value
			})

			fetch(DB + CAN_EDIT + '?act_id=' + this.$route.params.id + '&unit_id=' + UNIT_ID, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.readonly = res[0].czl_check_can_edit_unit == 't' ? false : true
			})
			.catch(err => console.log(err))

			fetch(DB + HEADER + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if (res) {
					for (let i in res[0]) {
						this[i] = res[0][i]
					}

					fetch(DB + LOCALFORESTRY + '?id=' + this.f_9)//forestry_id - f_9
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.data_location.localforestry = data
							EventBus.$emit(`fetch_localforestry_complete`, data)
						}
					})
					.catch(err => console.log(err))

					const region_id = this.f_12
					fetch(DB + SPECIES + `?region_id=${region_id}`, {
						credentials: 'include'
					})
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.data_location.species_list = data
							EventBus.$emit(`fetch_species_complete`, data)
						}
					})
					.catch(err => console.log(err))

				}

			})
			.catch(err => console.log(err))
			
			//---------------------
			


			//---------------------

			fetch(DB + ACT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				for (let i in res[0]) {
					//console.log(i, res[0][i])
					if (i === 'f_1' || i === 'f_3' || i === 'f_5' || i === 'f_7') {
						let d = moment(res[0][i], 'YYYY-MM-DD')
						// console.log(res[0][i], d.format('DD.MM.YYYY'))
						this[i] =  res[0][i] ? d.format('DD.MM.YYYY') : ''
					}
					else if (i === 'f_10') {
						this.f_10 = res[0][i] === 't' ? 1 : 0
					} else if (i === 'f_126') {
						if(res[0][i] === 't') {
							this.f_126 = true
						}
						if(res[0][i] === 'f') {
							this.f_126 = false
						}
					}
					else {
						this[i] = res[0][i]
					}
				}
				if(this.f_129 === null) {
					this.f_129 = 2
				}
			})
			.catch(err => console.log(err))

			fetch(DB + ACT_LOCATION + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if (res) {
					let tmp = []
					for (let i = 0; i < res.length; i++) {
						tmp.push({
							correct_f_16: res[i].f_16 === null ? 'field-error' : 'place-success', 
							correct_f_17: res[i].f_17 === null ? 'field-error' : 'place-success',
							correct_f_20: res[i].f_20 === null ? 'field-error' : 'place-success',
							correct_f_21: res[i].f_21 === null ? 'field-error' : 'place-success',
							correct_f_24: res[i].f_24 === null ? 'field-error' : 'place-success',
							...res[i]
						})
					}
					this.lines = tmp
					this.lines_correct = ''
					this.lines_loaded = true
					if(this.mzl_loaded)
					{
						this.calcSLP()
						this.calcSAT()
					}
				}
			})
			.catch(err => console.log(err))

			fetch(DB + CONCLUSION_EXIST + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if (res)
					this.conclusion_user_disabled = res[0].czl_if_conclusion_exist === 't'
			})
			.catch(err => console.log(err))

			const ua = navigator.userAgent

			if (ua.search('OPR/') > 0) {
				this.scroll_width = 15
			}

			/*for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = 0
				}

				for (let j = 0; j < this.lines.length; j++) {
					for (let i = 0; i < this.mzl.length; i++) {
						if (this.mzl[i].id == this.lines[j].f_16) {
							this.mzl[i].value += +this.lines[j].f_22
						}
					}
				}

			for (let i = 0; i < this.mzl.length; i++) {
					this.mzl[i].value = this.floatConvert(this.mzl[i])
				}*/
		},
		beforeDestroy () {
			EventBus.$off('edit_region')
			EventBus.$off('init_region_correct')
			EventBus.$off('edit_forestry')
			EventBus.$off('edit_localforestry')
			EventBus.$off('edit_subforestry')
			EventBus.$off('edit_conclusion_user')
			EventBus.$off('edit_species')
			EventBus.$off('edit_organization')
			EventBus.$off('edit_action_type')
			EventBus.$off('edit_deletion_reason')
			EventBus.$off('edit_damages')

			EventBus.$off('edit_lpo_reason')
			EventBus.$off('edit_lpo_method')
			EventBus.$off('edit_lpo_mode')
		},
		watch: {
			lines: {
		      handler: function (val, oldVal) {
		        this.checkS_LPO()
		        this.value_summ = 0
		        for(let line in this.lines)
		        {
		        	if(this.lines[line].f_21 != undefined)
		        		this.lines[line].f_21 = this.lines[line].f_21.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")

		        	if(this.lines[line].f_112 != undefined)
		        		this.lines[line].f_112 = this.lines[line].f_112.replace(/[^\d]/g, "")

		        	if(this.lines[line].f_113 != undefined)
		        		this.lines[line].f_113 = this.lines[line].f_113.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")

		        	if(this.lines[line].f_114 != undefined)
		        		this.lines[line].f_114 = this.lines[line].f_114.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")
					
					if(this.lines[line].f_131 != undefined)
		        		this.lines[line].f_131 = this.lines[line].f_131.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")

		        	if(this.lines[line].f_116 != undefined)
		        	{
		        		this.lines[line].f_116 = this.lines[line].f_116.replace(/[,]/g, ".").replace(/[.]{2,}/g, ".").replace(/[^\.\d]/g, "")
		        		this.value_summ += Number(this.lines[line].f_116)
		        	}
		        	

		        	this.lines[line].correct_f_23 = Number(this.lines[line].f_23) > Number(this.lines[line].f_21) ? 'field-error' : 'place-success'
		        }
		        this.value_summ = this.floatConvert(this.value_summ)
		      },
		      deep: true
		    },
			f_2 (e) {
				this.fields_correct.f_2 = (e === '' || e === null) ? 'field-error' : ''
			},
			f_13 (e) {
				this.checkS_LPO()
			},
			f_115 (e) {
				if(!e) {
					this.fields_correct.f_115 = ''
					return
				}

				const r = new RegExp("^-?\\d*(\\.\\d+)?$", "g") //numeric
				this.fields_correct.f_115 = r.test(e) ? '' : 'field-error'
			},
			f_1 (e) {
				const arr_f_5 = this.f_5.split('.')
				const date_f_5 = new Date(+arr_f_5[2], (+arr_f_5[1] - 1), +arr_f_5[0])
				const arr_f_1 = this.f_1.split('.')
				const date_f_1 = new Date(+arr_f_1[2], (+arr_f_1[1] - 1), +arr_f_1[0])
				if(date_f_5 < date_f_1)
				{
					this.fields_correct.f_1 = 'field-error'
					this.fields_correct.f_5 = 'field-error'
				} else {
					this.fields_correct.f_1 = (e === '' || e === null) ? 'field-error' : 'field-success'
					this.fields_correct.f_5 = (this.f_5 === '' || this.f_5 === null) ? 'field-error' : 'field-success'
					//this.fields_correct.f_5 = 'field-success'
				}
			},
			f_5 (e) {
				//debugger;
				const arr_f_5 = this.f_5.split('.')
				const date_f_5 = new Date(+arr_f_5[2], (+arr_f_5[1] - 1), +arr_f_5[0])
				const arr_f_1 = this.f_1.split('.')
				const date_f_1 = new Date(+arr_f_1[2], (+arr_f_1[1] - 1), +arr_f_1[0])
				if(date_f_5 < date_f_1)
				{
					this.fields_correct.f_1 = 'field-error'
					this.fields_correct.f_5 = 'field-error'
				} else 
				{
					//this.fields_correct.f_1 = 'field-success'
					this.fields_correct.f_1 = (this.f_5 === '' || this.f_5 === null) ? 'field-error' : 'field-success'
					this.fields_correct.f_5 = (e === '' || e === null) ? 'field-error' : 'field-success'
				}
			},
			mzl (e) {
				let result = this.mzl.slice(0)
				for(let e in result)
				{
					if(result[e].name == 'РАД')
					{
						this.mzlRAD = result[e]
						result.splice(e,1)
					}
				}
				this.mzlNoRAD = result
				this.mzlRAD = this.mzlRAD ? this.mzlRAD : {name: 'РАД', value: '0'}
			},
			f_126 (e) {
				this.fields_correct.f_126 = e === null ? 'field-error' : 'field-success'
			},
			f_127 (e) {
				this.fields_correct.f_127 = !e ? 'field-error' : 'field-success'
			},
			f_128 (e) {
				this.fields_correct.f_128 = !e ? 'field-error' : 'field-success'
			},
			f_130 (e) {
				this.fields_correct.f_130 = !e ? 'field-error' : 'field-success'
			}
		},
		updated() {
			/*if(document.querySelector('.table_body_wrap').scrollHeight > document.querySelector('.table_body_wrap').clientHeight)
				this.scroll_width = 17
			else
				this.scroll_width = 0
			console.warn(this.scroll_width)*/
		}
	}

	function commaToPeriod(str) {
		return str.replace(/,/g, ".")
	}
</script>

<style>

	div.datepicker {
		width: 100%;
	}

/* div.datepicker.table-control > input.form-control {
	border: none !important;
	height: 24px;
	margin: 0px;
	display: inline-table !important;
} */

div.datepicker.table-control > input.error {
	background-color: lightcoral;
}

td.error {
	background-color: lightcoral;
}

.my-control {
	padding-left: 5px !important;
	padding-top: 0px !important;
	padding-bottom: 0px !important;
	margin-bottom: 5px;
	height: 24px;
	display: inline-table !important;
	font-size: 12px !important;
}

select.my-control:not([size]):not([multiple]) {
	height: 24px;
}

.table-control {
	height: 24px;
	width: 100%;
	margin: 0px;
	border: none !important;
}

select.form-control:not([size]):not([multiple]) {
	height: 24px !important;
}

/* .grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
} */

.clearBtn {
	margin-right: 10px;
}

.left_input_wrapper {
	height: 30px;
    line-height: 24px;
}

.rent-title {
	width: 100px;
	text-align: center;
}

.no-bottom-border {
	border-bottom: none;
}

.no-right-border {
	border-right: none !important;
}
</style>


// WEBPACK FOOTER //
// editForm.vue?8ae16640